import { lazy } from "react";
import { setStudioView } from "../workspace/studio-views";
import type { VocalPanelProps } from "./VocalPanel";
const VocalPanel = lazy(() => import("./VocalPanel").then(module => ({ default: module.VocalPanel })));
const VocalEvidence = lazy(() => import("./VocalPanel").then(module => ({ default: module.VocalEvidence })));
const LipsyncBatchProgress = lazy(() => import("./VocalPanel").then(module => ({ default: module.LipsyncBatchProgress })));
import type { VocalReviewProps } from "./VocalReview";
const VocalReview = lazy(() => import("./VocalReview").then(module => ({ default: module.VocalReview })));
import type { LipsyncBatchReviewProps } from "./LipsyncBatchReview";
const LipsyncBatchReview = lazy(() => import("./LipsyncBatchReview").then(module => ({ default: module.LipsyncBatchReview })));
import type { VocalProject, VocalJob, VocalScene } from "./vocal-model";
export function mountVocalPanel(slot: HTMLElement, props: VocalPanelProps) {
  setStudioView("vocal-panel", `vocal-panel:${props.project.id}`, <VocalPanel {...props} />);
}
export function mountVocalReview(slot: HTMLElement, props: VocalReviewProps) {
  setStudioView("vocal-review", "vocal-selection-dialog", <VocalReview key={props.project.id} {...props} />);
}
export function mountVocalEvidence(slot: HTMLElement, scene: VocalScene) {
  setStudioView("vocal-evidence", "vocal-preview-evidence", <VocalEvidence scene={scene} />);
}
export function mountLipsyncProgress(
  slot: HTMLElement,
  project: VocalProject,
  job?: VocalJob,
) {
  setStudioView("vocal-progress", `vocal-progress:${project.id}`, <LipsyncBatchProgress project={project} job={job} />);
}
export function mountLipsyncBatchReview(
  slot: HTMLElement,
  props: LipsyncBatchReviewProps,
) {
  setStudioView("lipsync-review", "lipsync-cost-review", <LipsyncBatchReview key={props.project.id} {...props} />);
}
